import style from "./old_guide.module.css";

// old guide (used for old calling guide or guide with title component)
export default function OldGuide({
  state = 0,
  stateTitles,
}) {
  //Use for add class to selected state
  const currentState = state;

  return (
    <div className={style.purchase_state_wrapper}>
      <ul className={style.purchase_state_list}>
        {stateTitles.map((title, key) => (
          <li key={key} className={key <= currentState ? style.active : ""}>
            <div className={style.icon}></div>
            <p>{title}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}